import * as types from "../actions/types";
const initialState = {
    reservationtypes: [],
    calendarData: null,
    letting: null,
    options: null,
    agreements: [],
    country: [],
    texts: null,
    lang: null,
    languages: [],
    error: false,
    cookie: null,
    site: null,
    contact: null,
    agent: null,
    customTranslations: [],
    isModuleActive: true,
    isMyTicketModuleActive: true,
    externalProducs: [],
    isSu: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_CLIENTDATA:
            return {
                ...state,
                ...action.payload,
                externalProducts: action.payload.externalProducts?.sort((a, b) => {
                    const sortorderA = a.sort_order;
                    const sortorderB = b.sort_order;

                    if (sortorderA === sortorderB) {
                        return Math.random() - 0.5; // Randomize the order if sortorder is the same.
                    }

                    return sortorderA - sortorderB;
                }),
            };
        case types.FETCH_CLIENTDATA_FAILED:
            return {
                ...state,
                error: action.error,
            };
        case types.SET_CALENDAR_DATA:
            return {
                ...state,
                calendarData: action.payload,
                error: false,
            };
        case types.FETCH_CALENDAR_DATA_FAILED:
            return {
                ...state,
                calendarData: null,
                error: action.error,
            };
        case types.SET_TEXT_DATA:
            return {
                ...state,
                texts: action.texts,
            };
        case types.SET_LANG:
            return {
                ...state,
                lang: action.lang,
            };
        case types.SET_COOKIE:
            return {
                ...state,
                cookie: action.cookie,
            };
        case types.SET_LANGUAGES:
            return {
                ...state,
                languages: action.languages,
            };
        case types.SIGN_OUT_AGENT:
            return {
                ...state,
                agent: null,
            };
        case types.SET_IS_SU:
            return {
                ...state,
                isSu: action.isSu,
            };
        default:
            return {
                ...state,
            };
    }
};

export default reducer;
